import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { ReviewModeProvider } from "./context/ReviewModeContext";
import Login from "./components/Login";
import AdminLayout from "./layouts/AdminLayout";
// import CollapsibleSidebarTestLayout from "./layouts/CollapsibleSidebarTestLayout";
// import CollapsibleSidebarTest from "./pages/CollapsibleSidebarTest";

import Dashboard from "./pages/Dashboard";
import Upload from "./pages/Upload";
import SearchDocuments from "./pages/SearchDocuments";
import ArchivedPolicySearch from "./pages/ArchivedPolicySearch";
import ArchivedClaimsSearch from "./pages/ArchivedClaimsSearch";
import InboxReview from "./pages/InboxReview";
import Users from "./pages/Users";
import Roles from "./pages/Roles";
import Resources from "./pages/Resources";
import UserRoleAudit from "./pages/UserRoleAudit";
import AssignRoleResource from "./pages/AssignRoleResource";
import AssignUserRole from "./pages/AssignUserRole";
import AuditLogs from "./pages/AuditLogs";
import AccessReview from "./pages/AccessReview";
import LookupManagement from "./pages/LookupManagement";
import AdminDashboard from "./pages/AdminDashboard";
import Manage from "./pages/Manage";


import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  const isAuthenticated = useIsAuthenticated();

  return (
    <ReviewModeProvider>
      <BrowserRouter>
        <Routes>
          {!isAuthenticated ? (
            <Route path="*" element={<Login />} />
          ) : (
            <>
            {/* <Route path="/dev/collapsible-sidebar" element={<CollapsibleSidebarTestLayout />}>
              <Route index element={<CollapsibleSidebarTest />} />
            </Route> */}

            <Route path="/" element={<AdminLayout />}>
              {/* USER DASHBOARD */}
              <Route index element={<Dashboard />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/search" element={<SearchDocuments />} />
              <Route path="/policy-search" element={<ArchivedPolicySearch />} />
              <Route path="/claim-search" element={<ArchivedClaimsSearch />} />
              <Route path="/document-hub" element={<InboxReview />} />
              <Route path="/user-role-audit" element={<UserRoleAudit />} />
              <Route path="/lookups" element={<LookupManagement />} />

              {/* ADMIN DASHBOARD */}
              <Route
                path="admin-dashboard"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />

              <Route
                path="manage"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <Manage />
                  </ProtectedRoute>
                }
              />
              {/* USERS */}
              <Route
                path="users"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <Users />
                  </ProtectedRoute>
                }
              />

              {/* ROLES */}
              <Route
                path="roles"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <Roles />
                  </ProtectedRoute>
                }
              />

              {/* RESOURCES */}
              <Route
                path="resources"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <Resources />
                  </ProtectedRoute>
                }
              />

              {/* USER ↔ ROLE */}
              <Route
                path="assign-user-role"
                element={
                  <ProtectedRoute resource="ADMIN" access="WRITE">
                    <AssignUserRole />
                  </ProtectedRoute>
                }
              />

              {/* ROLE ↔ RESOURCE */}
              <Route
                path="assign-role-resource"
                element={
                  <ProtectedRoute resource="ADMIN" access="WRITE">
                    <AssignRoleResource />
                  </ProtectedRoute>
                }
              />

              {/* AUDIT LOGS */}
              <Route
                path="audit-logs"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <AuditLogs />
                  </ProtectedRoute>
                }
              />

              {/* ACCESS REVIEW  */}
              <Route
                path="access-review"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <AccessReview />
                  </ProtectedRoute>
                }
              />
            </Route>
            </>
          )}
        </Routes>
      </BrowserRouter>
    </ReviewModeProvider>
  );
}

export default App;
